import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetIntegrationHealthQueryVariables = Types.Exact<{
  integrationId: Types.Scalars['String']['input'];
}>;


export type GetIntegrationHealthQuery = { __typename?: 'Query', integrationHealth: { __typename?: 'IntegrationHealthDocument', isConnected: boolean, isHealthy: boolean, reasons: Array<Types.IntegrationHealthReason> } };

export type GetMergeDevSyncStateQueryVariables = Types.Exact<{
  integrationId: Types.Scalars['String']['input'];
}>;


export type GetMergeDevSyncStateQuery = { __typename?: 'Query', mergeDevSyncState: Array<{ __typename?: 'MergeDevSyncStateDocument', stateId: string, tenantId: string, entityType: Types.MergeDevImportEntityType, lastSyncTime?: Types.TDateISO | null, consecutiveFailures: number, recordsProcessed: number, recordsSucceeded: number, recordsFailed: number, lastSyncDurationMs: number }> };

export type GetMergeDevImportFailuresQueryVariables = Types.Exact<{
  integrationId: Types.Scalars['String']['input'];
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetMergeDevImportFailuresQuery = { __typename?: 'Query', mergeDevImportFailures: Array<{ __typename?: 'MergeDevImportFailureDocument', tenantId: string, entityType: Types.MergeDevImportEntityType, entityLabel: string, recordId: string, reason: string, timestamp: Types.TDateISO }> };

export type GetMergeDevExportsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.MergeDevExportDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.MergeDevExportDocumentSortInput> | Types.MergeDevExportDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetMergeDevExportsQuery = { __typename?: 'Query', mergeDevExports?: { __typename?: 'MergeDevExportsConnection', totalCount: number, nodes?: Array<{ __typename?: 'MergeDevExportDocument', id: string, entityType: Types.MergeDevExportEntityType, entityId: string, exportStatus: Types.MergeDevExportStatus, errorMessage?: string | null, mergeInvoiceId?: string | null, notExportedReason?: string | null, retryCount: number, updatedAt: Types.TDateISO }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type JoinedGlAccountFragment = { __typename?: 'MergeDevAccountDocument', importId: string, name: string, accountNumber: string, status: Types.MergeDevAccountStatus };

export type AccountingIntegrationConfigFragment = { __typename?: 'AccountingIntegrationConfigDocument', id: string, provider: Types.AccountingProvider, mergeDevAccountId?: string | null, outboundDetail: Types.OutboundDetailLevel, salesTaxAccountId?: string | null, fuelSurchargeAccountId?: string | null, freightAccountId?: string | null, depositAppliedAccountId?: string | null, roundingAdjustmentAccountId?: string | null, oneTimePullCompleted: boolean, oneTimePullCompletedAt?: Types.TDateISO | null, defaultIncomeAccount?: { __typename?: 'DefaultIncomeAccount', accountRemoteId: string, accountName: string, accountImportId: string } | null, defaultIncomeAccountJoined?: { __typename?: 'MergeDevAccountDocument', importId: string, name: string, accountNumber: string, status: Types.MergeDevAccountStatus } | null, salesTaxAccount?: { __typename?: 'MergeDevAccountDocument', importId: string, name: string, accountNumber: string, status: Types.MergeDevAccountStatus } | null, fuelSurchargeAccount?: { __typename?: 'MergeDevAccountDocument', importId: string, name: string, accountNumber: string, status: Types.MergeDevAccountStatus } | null, freightAccount?: { __typename?: 'MergeDevAccountDocument', importId: string, name: string, accountNumber: string, status: Types.MergeDevAccountStatus } | null, depositAppliedAccount?: { __typename?: 'MergeDevAccountDocument', importId: string, name: string, accountNumber: string, status: Types.MergeDevAccountStatus } | null, roundingAdjustmentAccount?: { __typename?: 'MergeDevAccountDocument', importId: string, name: string, accountNumber: string, status: Types.MergeDevAccountStatus } | null, placeholderRefusals: Array<{ __typename?: 'AccountingPlaceholderRefusal', purpose: Types.AccountingPlaceholderPurpose, accountImportId: string, accountName?: string | null, reason: string, mergeProblemType?: string | null, refusedAt: Types.TDateISO }> };

export type GetAccountingIntegrationConfigQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAccountingIntegrationConfigQuery = { __typename?: 'Query', accountingIntegrationConfig: { __typename?: 'AccountingIntegrationConfigDocument', id: string, provider: Types.AccountingProvider, mergeDevAccountId?: string | null, outboundDetail: Types.OutboundDetailLevel, salesTaxAccountId?: string | null, fuelSurchargeAccountId?: string | null, freightAccountId?: string | null, depositAppliedAccountId?: string | null, roundingAdjustmentAccountId?: string | null, oneTimePullCompleted: boolean, oneTimePullCompletedAt?: Types.TDateISO | null, defaultIncomeAccount?: { __typename?: 'DefaultIncomeAccount', accountRemoteId: string, accountName: string, accountImportId: string } | null, defaultIncomeAccountJoined?: { __typename?: 'MergeDevAccountDocument', importId: string, name: string, accountNumber: string, status: Types.MergeDevAccountStatus } | null, salesTaxAccount?: { __typename?: 'MergeDevAccountDocument', importId: string, name: string, accountNumber: string, status: Types.MergeDevAccountStatus } | null, fuelSurchargeAccount?: { __typename?: 'MergeDevAccountDocument', importId: string, name: string, accountNumber: string, status: Types.MergeDevAccountStatus } | null, freightAccount?: { __typename?: 'MergeDevAccountDocument', importId: string, name: string, accountNumber: string, status: Types.MergeDevAccountStatus } | null, depositAppliedAccount?: { __typename?: 'MergeDevAccountDocument', importId: string, name: string, accountNumber: string, status: Types.MergeDevAccountStatus } | null, roundingAdjustmentAccount?: { __typename?: 'MergeDevAccountDocument', importId: string, name: string, accountNumber: string, status: Types.MergeDevAccountStatus } | null, placeholderRefusals: Array<{ __typename?: 'AccountingPlaceholderRefusal', purpose: Types.AccountingPlaceholderPurpose, accountImportId: string, accountName?: string | null, reason: string, mergeProblemType?: string | null, refusedAt: Types.TDateISO }> } };

export type GetRevenueRoutingCoverageQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetRevenueRoutingCoverageQuery = { __typename?: 'Query', revenueRoutingCoverage: { __typename?: 'RevenueRoutingCoverage', customerTypesMapped: number, customerTypesTotal: number, itemsMapped: number, itemsTotal: number, categoriesMapped: number, categoriesTotal: number, defaultSet: boolean, categoryConflictCount: number, categoryConflictItemIds: Array<string>, staleMappings: Array<{ __typename?: 'StaleRevenueMapping', level: Types.MergeDevRevenueRung, accountImportId: string, accountName: string }> } };

export const JoinedGlAccountFragmentDoc = new TypedDocumentString(`
    fragment JoinedGlAccount on MergeDevAccountDocument {
  importId
  name
  accountNumber
  status
}
    `, {"fragmentName":"JoinedGlAccount"});
export const AccountingIntegrationConfigFragmentDoc = new TypedDocumentString(`
    fragment AccountingIntegrationConfig on AccountingIntegrationConfigDocument {
  id
  provider
  mergeDevAccountId
  outboundDetail
  defaultIncomeAccount {
    accountRemoteId
    accountName
    accountImportId
  }
  defaultIncomeAccountJoined {
    ...JoinedGlAccount
  }
  salesTaxAccountId
  salesTaxAccount {
    ...JoinedGlAccount
  }
  fuelSurchargeAccountId
  fuelSurchargeAccount {
    ...JoinedGlAccount
  }
  freightAccountId
  freightAccount {
    ...JoinedGlAccount
  }
  depositAppliedAccountId
  depositAppliedAccount {
    ...JoinedGlAccount
  }
  roundingAdjustmentAccountId
  roundingAdjustmentAccount {
    ...JoinedGlAccount
  }
  oneTimePullCompleted
  oneTimePullCompletedAt
  placeholderRefusals {
    purpose
    accountImportId
    accountName
    reason
    mergeProblemType
    refusedAt
  }
}
    fragment JoinedGlAccount on MergeDevAccountDocument {
  importId
  name
  accountNumber
  status
}`, {"fragmentName":"AccountingIntegrationConfig"});
export const GetIntegrationHealthDocument = new TypedDocumentString(`
    query GetIntegrationHealth($integrationId: String!) {
  integrationHealth(integrationId: $integrationId) {
    isConnected
    isHealthy
    reasons
  }
}
    `);
export const GetMergeDevSyncStateDocument = new TypedDocumentString(`
    query GetMergeDevSyncState($integrationId: String!) {
  mergeDevSyncState(integrationId: $integrationId) {
    stateId
    tenantId
    entityType
    lastSyncTime
    consecutiveFailures
    recordsProcessed
    recordsSucceeded
    recordsFailed
    lastSyncDurationMs
  }
}
    `);
export const GetMergeDevImportFailuresDocument = new TypedDocumentString(`
    query GetMergeDevImportFailures($integrationId: String!, $last: Int) {
  mergeDevImportFailures(integrationId: $integrationId, last: $last) {
    tenantId
    entityType
    entityLabel
    recordId
    reason
    timestamp
  }
}
    `);
export const GetMergeDevExportsDocument = new TypedDocumentString(`
    query GetMergeDevExports($where: MergeDevExportDocumentFilterInput, $order: [MergeDevExportDocumentSortInput!], $first: Int, $after: String) {
  mergeDevExports(where: $where, order: $order, first: $first, after: $after) {
    nodes {
      id
      entityType
      entityId
      exportStatus
      errorMessage
      mergeInvoiceId
      notExportedReason
      retryCount
      updatedAt
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetAccountingIntegrationConfigDocument = new TypedDocumentString(`
    query GetAccountingIntegrationConfig {
  accountingIntegrationConfig {
    ...AccountingIntegrationConfig
  }
}
    fragment JoinedGlAccount on MergeDevAccountDocument {
  importId
  name
  accountNumber
  status
}
fragment AccountingIntegrationConfig on AccountingIntegrationConfigDocument {
  id
  provider
  mergeDevAccountId
  outboundDetail
  defaultIncomeAccount {
    accountRemoteId
    accountName
    accountImportId
  }
  defaultIncomeAccountJoined {
    ...JoinedGlAccount
  }
  salesTaxAccountId
  salesTaxAccount {
    ...JoinedGlAccount
  }
  fuelSurchargeAccountId
  fuelSurchargeAccount {
    ...JoinedGlAccount
  }
  freightAccountId
  freightAccount {
    ...JoinedGlAccount
  }
  depositAppliedAccountId
  depositAppliedAccount {
    ...JoinedGlAccount
  }
  roundingAdjustmentAccountId
  roundingAdjustmentAccount {
    ...JoinedGlAccount
  }
  oneTimePullCompleted
  oneTimePullCompletedAt
  placeholderRefusals {
    purpose
    accountImportId
    accountName
    reason
    mergeProblemType
    refusedAt
  }
}`);
export const GetRevenueRoutingCoverageDocument = new TypedDocumentString(`
    query GetRevenueRoutingCoverage {
  revenueRoutingCoverage {
    customerTypesMapped
    customerTypesTotal
    itemsMapped
    itemsTotal
    categoriesMapped
    categoriesTotal
    defaultSet
    staleMappings {
      level
      accountImportId
      accountName
    }
    categoryConflictCount
    categoryConflictItemIds
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetIntegrationHealth: build.query<GetIntegrationHealthQuery, GetIntegrationHealthQueryVariables>({
      query: (variables) => ({ document: GetIntegrationHealthDocument, variables })
    }),
    GetMergeDevSyncState: build.query<GetMergeDevSyncStateQuery, GetMergeDevSyncStateQueryVariables>({
      query: (variables) => ({ document: GetMergeDevSyncStateDocument, variables })
    }),
    GetMergeDevImportFailures: build.query<GetMergeDevImportFailuresQuery, GetMergeDevImportFailuresQueryVariables>({
      query: (variables) => ({ document: GetMergeDevImportFailuresDocument, variables })
    }),
    GetMergeDevExports: build.query<GetMergeDevExportsQuery, GetMergeDevExportsQueryVariables | void>({
      query: (variables) => ({ document: GetMergeDevExportsDocument, variables })
    }),
    GetAccountingIntegrationConfig: build.query<GetAccountingIntegrationConfigQuery, GetAccountingIntegrationConfigQueryVariables | void>({
      query: (variables) => ({ document: GetAccountingIntegrationConfigDocument, variables })
    }),
    GetRevenueRoutingCoverage: build.query<GetRevenueRoutingCoverageQuery, GetRevenueRoutingCoverageQueryVariables | void>({
      query: (variables) => ({ document: GetRevenueRoutingCoverageDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetIntegrationHealthQuery, useLazyGetIntegrationHealthQuery, useGetMergeDevSyncStateQuery, useLazyGetMergeDevSyncStateQuery, useGetMergeDevImportFailuresQuery, useLazyGetMergeDevImportFailuresQuery, useGetMergeDevExportsQuery, useLazyGetMergeDevExportsQuery, useGetAccountingIntegrationConfigQuery, useLazyGetAccountingIntegrationConfigQuery, useGetRevenueRoutingCoverageQuery, useLazyGetRevenueRoutingCoverageQuery } = injectedRtkApi;
